import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Settings({ children }) {
  return (
    <div>
      <CustomPageHeader icon='sliders' text='Settings' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/index.js